import React, { Component } from 'react';

class UserPhoto extends Component {

    render() {
        return (
            <>
                <div className="ebs-foto-perfil" name="meu-cadastro" style={{ backgroundImage: `url(${this.props.src})` }}>
                </div>
            </>
        )
    }
}

export default UserPhoto;